import { TransactionErrorCode } from '@/types/api/bankid/v2/transaction-error-code.enum';

export function transactionErrorMessage(code: TransactionErrorCode): string {
  // prettier-ignore
  switch (code) {
    case TransactionErrorCode.CertificateError:   return 'Certifikatfel – kontrollera din e-legitimation.';
    case TransactionErrorCode.ProviderError:      return 'Ett fel uppstod hos Rocker.';
    case TransactionErrorCode.Unknown:            return 'Ett okänt fel inträffade.';
    case TransactionErrorCode.InvalidParameters:  return 'Ogiltiga parametrar angavs.';
    case TransactionErrorCode.AlreadyInProgress:  return 'En verifiering är redan påbörjad.';
    case TransactionErrorCode.StartFailed:        return 'BankID startades aldrig.';
    case TransactionErrorCode.Cancelled:          return 'Verifieringen avbröts.';
    case TransactionErrorCode.UserCancelled:      return 'Du avbröt verifieringen.';
    case TransactionErrorCode.ExpiredTransaction: return 'Verifieringen har löpt ut.';
    case TransactionErrorCode.ClientError:        return 'Ett fel uppstod i klienten.';
    case TransactionErrorCode.ValidationFailed:   return 'Valideringen av signatur misslyckades.';
    case TransactionErrorCode.UnderageUser:       return 'Du måste vara minst 18 år.';
    default:                                      return 'Ett okänt fel inträffade.';
  }
}
